if (!customElements.get('mewside-lookout')) {
  customElements.define('mewside-lookout', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('.ml-product-form');
      this.variant = this.querySelector('[data-variant]');
      this.buttons = [...this.querySelectorAll('[data-submit]')];
      this.error = this.querySelector('[data-form-error]');
      this.busy = false;
      this.querySelectorAll('[data-photo]').forEach(button => {
        button.addEventListener('click', () => {
          const counter = this.querySelector('[data-gallery-count]');
          if (counter) counter.textContent = button.dataset.photo + ' / ' + this.querySelectorAll('[data-photo]').length;
          this.querySelectorAll('[data-panel]').forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.photo; });
          this.querySelectorAll('[data-photo]').forEach(thumb => { thumb.setAttribute('aria-pressed', String(thumb === button)); });
        });
      });
      const gallery = this.querySelector('.ml-gallery-main');
      let touchX = null;
      gallery?.addEventListener('touchstart', event => { touchX = event.touches[0].clientX; }, {passive: true});
      gallery?.addEventListener('touchend', event => {
        if (touchX === null) return;
        const dx = event.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) < 45) return;
        const thumbs = [...this.querySelectorAll('[data-photo]')];
        const current = thumbs.findIndex(el => el.getAttribute('aria-pressed') === 'true');
        thumbs[(current + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length]?.click();
      }, {passive: true});
      this.querySelectorAll('[data-offer]').forEach(input => input.addEventListener('change', () => this.updateVariant()));
      this.variant?.addEventListener('change', () => this.updateVariant());
      this.form?.addEventListener('submit', event => this.addPair(event));
      this.updateVariant();
      this.sticky = this.querySelector('[data-sticky]');
      const offer = this.querySelector('.ml-add');
      if (offer && this.form && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const show = entries[0].intersectionRatio < 0.8 && (window.matchMedia('(max-width: 749px)').matches || entries[0].boundingClientRect.bottom < 0);
          this.sticky.hidden = !show;
          document.body.classList.toggle('ml-sticky-visible', show);
        }, {threshold: [0, 0.8]});
        this.observer.observe(offer);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      document.body.classList.remove('ml-sticky-visible');
    }
    updateVariant() {
      const selected = this.variant?.selectedOptions[0];
      const offer = this.querySelector('[data-offer]:checked');
      this.quantity = Number(offer?.value || 2);
      this.available = selected?.dataset.available === 'true' && this.dataset.enabled === 'true' && this.dataset.eligible === 'true' && this.dataset.sellingPlan !== 'true';
      if (selected?.dataset.tracked === 'true' && Number(selected.dataset.inventory) < this.quantity) this.available = false;
      if (selected) {
        this.querySelectorAll('[data-total-price]').forEach(el => { el.textContent = this.quantity === 4 ? selected.dataset.fourPrice : selected.dataset.price; });
        this.querySelectorAll('[data-bundle-price]').forEach(el => { el.textContent = el.dataset.bundlePrice === '4' ? selected.dataset.fourPrice : selected.dataset.price; });
      }
      this.querySelectorAll('[data-offer-count]').forEach(el => { el.textContent = offer?.dataset.count || ''; });
      this.querySelectorAll('[data-offer-title]').forEach(el => { el.textContent = offer?.dataset.title || ''; });
      if (selected) {
        this.querySelectorAll('[data-price-history]').forEach(el => { el.hidden = selected.dataset.onSale !== 'true' || this.quantity === 4; });
        this.querySelectorAll('[data-compare-price]').forEach(el => { el.textContent = this.quantity === 4 ? selected.dataset.fourCompare : selected.dataset.compare; });
      }
      this.querySelectorAll('[data-stock-status]').forEach(el => { el.hidden = !this.available; });
      this.buttons.forEach(button => {
        button.disabled = !this.available || this.busy;
        button.querySelector('span').textContent = this.busy ? this.dataset.busy : this.available ? (offer?.dataset.label || this.dataset.addLabel) : this.dataset.unavailable;
      });
    }
    async addPair(event) {
      event.preventDefault();
      if (this.busy || !this.available) return;
      this.busy = true;
      this.error.hidden = true;
      this.updateVariant();
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items: [{id: this.variant.value, quantity: this.quantity}]})
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        window.location.assign(this.dataset.cartUrl);
      } catch (error) {
        this.error.textContent = error.message && !(error instanceof TypeError) && !(error instanceof SyntaxError) ? error.message : this.dataset.error;
        this.error.hidden = false;
        this.busy = false;
        this.updateVariant();
      }
    }
  });
}
